<style scoped>
    .expand-row{
        margin-bottom: 16px;
    }
</style>
<template>
    <div class="table_expand_th_padding">
        <!-- {{rows3}} -->
        <Table border :columns="columns2" :data="data2" class="border" ></Table>
        <!-- <button></button> -->
    </div>
</template>
<script>
    import axios from 'axios';
    import config from 'config/apiConfig'
    import language from 'api/language.js'
    export default {
        data(){
            return{
              language:{},
                columns2: [
                    {
                      title: language.shouhuokehu,
                      key: 'customerName',
                      align: 'center',
                      width: 80,
                    },
                    {
                        title: language.cangku,
                        key: 'warehouseName',
                        align: 'center',
                        width: 50,
                    },
                    {
                      title: language.kunbaohao,
                      key: 'serialCode',
                      align: 'center',
                      width:150,
                      },
                    {
                      title: language.pinzhong,
                      key: 'categoryCode',
                      align: 'center',
                      width: 50,
                    },
                    {
                      title: language.paihao,
                      key: 'shopsign',
                      align: 'center',
                      width: 120,
                    },
                    {
                      title: language.guige,
                      key: 'rawSpec',
                      align: 'center',
                      width: 80,
                      },
                    {
                      title: language.jiagongzhongliang,
                      key: 'processingWeight',
                      align: 'center',
                      width: 70,
                    },
                    {
                      title: language.neiwaiban,
                      key: 'exposedName',
                      align: 'center',
                      width: 80,
                      },
                    {
                      title: language.rukuriqi,
                      key: 'stockInDate',
                      align: 'center',
                      width: 80,
                    },
                    {
                        title: language.mujuanhao,
                        key: 'reelNo',
                        align: 'center',
                        width: 85,
                      },
                    {
                      title: language.mujuanguige,
                      key: 'pieceSpec',
                      align: 'center',
                      width: 75,
                    },
                    {
                        title: language.mujuanzhongliang,
                        key: 'rawPrimaryQty',
                        align: 'center',
                        width: 75,
                    },
                    {
                        title: language.shengchanzhuangtai,
                        key: 'produceStatusName',
                        align: 'center',
                        width: 70,
                    },
                    {
                        title: language.shenpizhuangtai,
                        key: 'statusName',
                        align: 'center',
                        width: 70,
                    },
                    {
                        title: language.jiaohuoqi,
                        key: 'deliveryDate',
                        align: 'center',
                        width: 80,
                    },
                    {
                        title: language.shengchanjiaohuoqi,
                        key: 'productDeliveryDate',
                        align: 'center',
                        width: 80,

                    },
                    {
                        title: language.chengpinkunbaohao,
                        key: 'productSerialCodes',
                        align: 'center',
                        width: 200,
                        render:(h, params) => {
                          const spesData = params.row.productSerialCodes;
                          var spesVal = "";
                          spesData.forEach(r=>{
                            // console.log(r)
                              spesVal += r+" "
                          })
                          return h('span',spesVal );
                        }
                    },
                    {
                        title: language.chengpinguige,
                        key: 'spes',
                        align: 'center',
                        width: 75,
                        render:(h, params) => {
                          const spesData = params.row.spes;
                          var spesVal = "";
                          spesData.forEach(r=>{
                            // console.log(r)
                              spesVal += r+" "
                          })
                          return h('span',spesVal );
                        }
                    },
                    {
                        title: language.chengpinzhongliang,
                        key: 'prodWeight',
                        align: 'center',
                        width: 70,
                        render:(h,params) =>{
                            // console.log(params.row.prodWeight)
                            if(params.row.prodWeight!=null){
                                const spesData = params.row.prodWeight;
                                var spesVal = "";
                                spesData.forEach(r=>{
                                    spesVal += r+" "
                                })
                                return h('span', spesVal)
                            }
                    }

                    },
                    {
                        title: language.chengpinshuliang,
                        key: 'prodQty',
                        align: 'center',
                        width: 70,
                        render:(h, params) => {
                          const spesData = params.row.prodQty;
                          var spesVal = "";
                          spesData.forEach(r=>{
                              spesVal += r+" "
                          })
                          return h('span',spesVal);
                        }
                    },
                    {
                        title: language.beizhu,
                        key: 'remarks',
                        align: 'center',
                        width: 250,
                    },
                    {
                        title: language.caozuo,
                        key: 'prodQty',
                        align:'center',
                        width:70,
                        border:'none',
                        render:(h,params)=>{
                          // console.log(params.row.status,params.row.produceStatus)
                          if(params.row.status == 20){
                            // alert(111)
                            return h('div',[
                                h('Button',{
                                    on:{
                                        click:()=>{
                                          let that = this
                                            this.removelist(params)
                                        },
                                    },
                                    style:{
                                      border:"1px solid white",
                                      backgroundColor:"white"
                                    }
                                },[
                                    h('icon',{
                                        props:{

                                            type:'reply-all'
                                        },
                                        style:{
                                            color:'#0066ff',
                                            fontSize:'20px',
                                            textAlign:'center',
                                            border:'none',
                                        }
                                    })
                                ])
                                ]

                            )
                          }
                          else if(params.row.produceStatus==60){
                                return h('div',[
                                    h('Button',{
                                        on:{
                                            click:()=>{
                                              let that = this
                                                this.removelists(params)
                                            },
                                        },
                                        style:{
                                          border:"1px solid white",
                                          backgroundColor:'white',
                                          fontSize:'15px'
                                          // backgroundColor:"red"
                                        }
                                    },[
                                        h('Icon',{
                                            props:{
                                                type:"ios-cart"
                                            },
                                        })
                                    ])
                                    ]

                            )
                          }
                          else{
                            return ""
                          }
                        }
                    }
                ],
                data2:[],
                row:this.rows3,
                datalist:[],
                // data3:[],
            }
        },
        props: {
            rows3: Object,
        },
        methods:{
        removelists(params){
            let data3="";
            let data4=[];
            let paramsData={}
            data3=params.row.productList
            for(var i=0;i<data3.length;i++){
            data4.push(""+data3[i].productSerialCodes+"")
                
            }
            paramsData.productSerialCodes=data4            
            let that = this
            axios.post(config.addCartByJg,paramsData).then(function(response){
                if(response.data.resultCode==0){
                   // that.$Modal.info({

                   //          // title: title,
                   //          content: "添加购物车成功，请到提货申请购物车查看！"
                        
                   //    })
                    that.$Message.info(response.data.resultMsgDetail)
                    }else{
                      // alert("添加购物车成功，请到提货申请购物车查看！")
                      that.$Modal.info({

                            // title: title,
                            content: response.data.resultMsgDetail
                        
                      })
                    }
            })
        },
        rng(indexs){
            let that=this;
            that.language = language;
            axios.post(config.queryJGApplyDetail,{"applyId": that.row.applyId}).then(function(response){
                that.$emit('on-change',response.data.resultData)
                // that.$emit('on-change',response)
                that.data2=response.data.resultData;
                var arrArry = [];
                arrArry.push(response.data.resultData);
                var len =  that.data2.length;
                var len1 = response.data.resultData.length;
                var len2 = 0;
                var len3 = 0;

                for(var i=0;i<len;i++){
                    that.data2[i].spes = [];
                    that.data2[i].prodWeight = [];
                    that.data2[i].prodQty = [];
                    that.data2[i].productSerialCodes = [];

                    len2 = that.data2[i].productList.length;
                        for(var j=0;j<len2;j++){
                            if(that.data2[i].productList[j].spes != null){
                                that.data2[i].spes.push(that.data2[i].productList[j].spes);
                            }
                            if(that.data2[i].productList[j].prodWeight != null){
                                that.data2[i].prodWeight.push(that.data2[i].productList[j].prodWeight);
                            }
                            if(that.data2[i].productList[j].prodQty != null){
                                that.data2[i].prodQty.push(that.data2[i].productList[j].prodQty);
                            }

                            if(that.data2[i].productList[j].productSerialCodes != null){
                                that.data2[i].productSerialCodes.push(that.data2[i].productList[j].productSerialCodes);
                            }
                            for(var k=0;k<len3;k++){
                                that.data2[i].productSerialCodes.push(that.data2[i].productList[j].productSerialCodes[k]);
                            }
                        }
                // }
                }
            }).catch(function(error){
            })
        },
        removelist(params){
            let that = this;
            let paramsData={
                applyCode:that.row.applyCode,
                serialCode:that.data2[params.index].serialCode,
                lang:"ko_KR"
            }
            axios.post(config.reverseJGApply,paramsData).then(function(response){
                if(response.data.resultCode==1){
                  // console.log()
                    that.$Message.info(language.caozuochenggong)
                    
                    that.rng()
            }
            if(response.data.resultCode==0){

                that.$Message.info(response.data.fsuffix)
                that.$emit('on-change',response.data.resultMsgDetail)
            }
            })
            }
        },
        mounted(){
             // console.log(this)
             this.rng()
        }

    };
</script>



// WEBPACK FOOTER //
// table-expand.vue?0a5bc43c